import React from "react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

export default function SignUp({userEmails}) {
    const[Form,SetForm]=useState({
        full_name:"",
        email:"",
        password:"",
        phone_number:""
    })
    const navigate=useNavigate()
    function handleClick(){
        console.log("clicked")
        navigate('/')
    }
    function handleChange(event) {
        const { name, value } = event.target;
        SetForm((prevForm) => ({ ...prevForm, [name]: value }));
      }
      function handleClick2() {
        console.log("Form", Form);
        const isEmailExists = userEmails.includes(Form.email);
      
        if (isEmailExists) {
          alert("Email already exists");
        } else if (Form.password.length < 8 || Form.phone_number.length !== 10) {
          alert("Password is too short or Phone Number is invalid");
        } else {
          fetch("https://flask-api-dlzd.onrender.com/users", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              full_name: Form.full_name,
              email: Form.email,
              password: parseInt(Form.password),
              phone_number: parseInt(Form.phone_number)
            })
          })
            .then((resp) => resp.json())
            .then((data) => console.log(data));
            navigate("/home")
        }
      }
      
  return (
    <>
      <div className="cont">
      <div className="form sign-in">
        <h2>Log In To have Full access to our Website,</h2>
        <label>
          <span>Full Name</span>
          <input type="name" name="full_name" value={Form.full_name} onChange={handleChange} />
        </label>
        <label>
          <span>email</span>
          <input type="email" name="email" value={Form.email} onChange={handleChange}/>
        </label>
        <label>
          <span>Password</span>
          <input type="password" name="password" value={Form.password} onChange={handleChange} />
        </label>
        <label>
          <span>Phone Number</span>
          <input type="numeric" name="phone_number" value={Form.phone_number} onChange={handleChange}/>
        </label>
        <p className="forgot-pass">Forgot password?</p>
        <button type="button" className="submit" onClick={handleClick2}>Sign In</button>
        <button type="button" className="fb-btn">Connect with <span>facebook</span></button>
      </div>
      <div className="sub-cont">
        <div className="img">
          <div className="img__text m--up">
          <h2>One of us?</h2>
            <p>If you already has an account, just sign in. We've missed you!</p>
          </div>
          <div className="img__btn"  onClick={handleClick}>
            <span className="m--up">Sign In</span>
            <span className="m--in">Sign Up</span>
          </div>
        </div>
        <div className="form sign-up">
          <h2>Time to feel like home,</h2>
          <label>
            <span>Name</span>
            <input type="text" />
          </label>
          <label>
            <span>Email</span>
            <input type="email" />
          </label>
          <label>
            <span>Password</span>
            <input type="password" />
          </label>
          <button type="button" className="submit" >Sign Up</button>
          <button type="button" className="fb-btn">Join with <span>facebook</span></button>
        </div>
      </div>
    </div>
    </>
  );
}
